import * as XLSX from "xlsx";

interface UseDownloadProps {
    results: Record<string, string>[];
    selectedSearch: string;
}

export function useDownload({ results, selectedSearch }: UseDownloadProps) {
    function downloadListing() {
        const ws = XLSX.utils.json_to_sheet(results);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, `Campos do ${selectedSearch}`);
        XLSX.writeFile(wb, `fields_${selectedSearch}_zendesk.xlsx`);
    }

    return {
        downloadListing
    }
}